import { getAuthenticated, postAuthenticated } from './http';

const GOOGLE_CALENDAR_BASE = '/api/integrations/google-calendar';

export const fetchGoogleCalendarStatus = () =>
  getAuthenticated(`${GOOGLE_CALENDAR_BASE}/status`);

export const startGoogleCalendarConnection = (returnTo = '/settings') =>
  postAuthenticated(`${GOOGLE_CALENDAR_BASE}/connect`, { returnTo });

export const disconnectGoogleCalendar = () =>
  postAuthenticated(`${GOOGLE_CALENDAR_BASE}/disconnect`, {});
